module.exports = __webpack_public_path__ + "static/panel-8699025df1e4a6ae05376f12a5677323.png";